// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox-module_checkbox__QVn9V {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 9px;
    border-radius: 50%;
    position: relative;
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
}

.checkbox-module_checkbox__QVn9V.checkbox-module_disabled__B9nul {
    cursor: default;
    opacity: 0.38;
}

.checkbox-module_input__lnElP {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    opacity: 0;
    cursor: inherit;
}

.checkbox-module_box__WKlRs {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border: 2px solid currentColor;
    border-radius: 2px;
    box-sizing: border-box;
    color: inherit;
    background-color: transparent;
    transition: background-color 150ms ease, border-color 150ms ease;
}

.checkbox-module_checkbox__QVn9V.checkbox-module_checked___yh6_ .checkbox-module_box__WKlRs {
    background-color: currentColor;
    border-color: currentColor;
}

.checkbox-module_checkmark__a_wq4 {
    display: none;
    width: 100%;
    height: 100%;
}

.checkbox-module_checkbox__QVn9V.checkbox-module_checked___yh6_ .checkbox-module_checkmark__a_wq4 {
    display: block;
}
`, "",{"version":3,"sources":["webpack://./../../packages/core-widgets/src/checkbox/checkbox.module.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,6BAA6B;IAC7B,gEAAgE;AACpE;;AAEA;IACI,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".checkbox {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    padding: 9px;\n    border-radius: 50%;\n    position: relative;\n    box-sizing: border-box;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.checkbox.disabled {\n    cursor: default;\n    opacity: 0.38;\n}\n\n.input {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    padding: 0;\n    opacity: 0;\n    cursor: inherit;\n}\n\n.box {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n    height: 18px;\n    border: 2px solid currentColor;\n    border-radius: 2px;\n    box-sizing: border-box;\n    color: inherit;\n    background-color: transparent;\n    transition: background-color 150ms ease, border-color 150ms ease;\n}\n\n.checkbox.checked .box {\n    background-color: currentColor;\n    border-color: currentColor;\n}\n\n.checkmark {\n    display: none;\n    width: 100%;\n    height: 100%;\n}\n\n.checkbox.checked .checkmark {\n    display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox": `checkbox-module_checkbox__QVn9V`,
	"disabled": `checkbox-module_disabled__B9nul`,
	"input": `checkbox-module_input__lnElP`,
	"box": `checkbox-module_box__WKlRs`,
	"checked": `checkbox-module_checked___yh6_`,
	"checkmark": `checkbox-module_checkmark__a_wq4`
};
export default ___CSS_LOADER_EXPORT___;
